import React from 'react';

import { SkeletonBlock } from '@/components/common';

const LateCardSkeleton = (): React.ReactElement => <SkeletonBlock />;

export { LateCardSkeleton };
